/**
 * OA Product Block — Collage, lightbox, sizes, cart, wishlist, tabs
 * Door Online Actief (online-actief.nl)
 */
(() => {
  function initProductBlock() {
    document.querySelectorAll('.oa-pb').forEach(block => {
      if (block._oaPB) return;
      block._oaPB = true;
      block._i18n = {};
      const i18nEl = document.getElementById('oa-wishlist-i18n') || block.querySelector('[data-oa-pb-i18n]');
      if (i18nEl) { try { block._i18n = JSON.parse(i18nEl.textContent || '{}'); } catch (e) {} }
      initScrollReveal(block);
      initCollageGallery(block);
      initHeroGallery(block);
      initMobileGallery(block);
      initSizeButtons(block);
      initAddToCart(block);
      initWishlist(block);
      initSizeGuide(block);
      initDesignsModal(block);
      initDesignsSliderDrag(block);
      initStickyCart(block);
      initTabs(block);
    });
  }

  /* ── Designs slider — sleepbaar met muis op desktop ── */
  function initDesignsSliderDrag(block) {
    const slider = block.querySelector('[data-oa-designs-slider]');
    if (!slider) return;
    let isDown = false, startX = 0, scrollStart = 0, moved = 0;
    slider.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      isDown = true; moved = 0;
      startX = e.pageX - slider.offsetLeft;
      scrollStart = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => { isDown = false; });
    slider.addEventListener('mouseup', () => { isDown = false; });
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.2;
      moved = Math.abs(walk);
      slider.scrollLeft = scrollStart - walk;
    });
    /* Klik op tile annuleren als er gesleept is */
    slider.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', (e) => { if (moved > 6) e.preventDefault(); });
    });
  }

  /* ── Scroll reveal ── */
  function initScrollReveal(block) {
    const targets = block.querySelectorAll(
      '.oa-pb__gallery, .oa-pb__info, .oa-pb__section, .oa-pb__cart-row, .oa-pb__usps, .oa-pb__payments, .oa-pb__description, .oa-pb__features, .oa-pb__tabs'
    );
    if (!targets.length) return;
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => { entry.target.classList.add('is-visible'); }, i * 80);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      targets.forEach(el => obs.observe(el));
    } else {
      targets.forEach(el => el.classList.add('is-visible'));
    }
  }

  /* ── Photo collage + lightbox ── */
  function initCollageGallery(block) {
    const items = block.querySelectorAll('[data-oa-pb-collage-item]');
    const heroImgs = block.querySelectorAll('[data-oa-pb-hero-img]');
    const lightbox = block.querySelector('[data-oa-pb-lightbox]');
    if ((!items.length && !heroImgs.length) || !lightbox) return;

    const lightboxImg = lightbox.querySelector('[data-oa-pb-lightbox-img]');
    const closeBtn = lightbox.querySelector('[data-oa-pb-lightbox-close]');
    const prevBtn = lightbox.querySelector('[data-oa-pb-lightbox-prev]');
    const nextBtn = lightbox.querySelector('[data-oa-pb-lightbox-next]');
    const counter = lightbox.querySelector('[data-oa-pb-lightbox-counter]');

    const allImages = [];
    const seenKeys = new Set();
    const imgKey = (url) => url.split('?')[0];
    const addImg = (url) => { const k = imgKey(url); if (!seenKeys.has(k)) { seenKeys.add(k); allImages.push(url); } };
    block.querySelectorAll('[data-oa-pb-collage-item]').forEach(item => { if (item.dataset.imageUrl) addImg(item.dataset.imageUrl); });
    heroImgs.forEach(img => { addImg(img.dataset.full || img.src); });
    block.querySelectorAll('[data-oa-pb-mobile-gallery] .oa-pb__mobile-slide img').forEach(img => { addImg(img.src.replace(/width=\d+/, 'width=1200')); });

    let currentIndex = 0;
    function showImage(index) {
      if (index < 0) index = allImages.length - 1;
      if (index >= allImages.length) index = 0;
      currentIndex = index;
      lightboxImg.style.opacity = '0';
      setTimeout(() => {
        lightboxImg.src = allImages[currentIndex];
        lightboxImg.alt = 'Product afbeelding ' + (currentIndex + 1);
        lightboxImg.onload = () => { lightboxImg.style.opacity = '1'; };
      }, 120);
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + allImages.length;
    }

    function openLB(index) { showImage(index); lightbox.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeLB() { lightbox.classList.remove('is-open'); document.body.style.overflow = ''; }

    items.forEach(item => {
      item.addEventListener('click', () => openLB(parseInt(item.dataset.collageIndex, 10) || 0));
    });
    heroImgs.forEach(img => {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', () => openLB(parseInt(img.dataset.index, 10) || 0));
    });
    const moreBtn = block.querySelector('[data-oa-pb-thumb-more]');
    if (moreBtn) moreBtn.addEventListener('click', () => openLB(parseInt(moreBtn.dataset.moreIndex, 10) || 0));
    if (closeBtn) closeBtn.addEventListener('click', closeLB);
    if (prevBtn) prevBtn.addEventListener('click', () => showImage(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => showImage(currentIndex + 1));
    lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLB(); });
    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLB();
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    let touchStartX = 0;
    lightboxImg.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    lightboxImg.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { diff > 0 ? showImage(currentIndex + 1) : showImage(currentIndex - 1); }
    }, { passive: true });

    /* Mouse-drag swiping (laptop) */
    let mDown = false, mStartX = 0, mMoved = 0;
    lightboxImg.style.cursor = 'grab';
    lightboxImg.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      mDown = true; mStartX = e.clientX; mMoved = 0;
      lightboxImg.style.cursor = 'grabbing';
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => {
      if (!mDown) return;
      mMoved = e.clientX - mStartX;
      lightboxImg.style.transform = 'translateX(' + (mMoved * 0.4) + 'px)';
    });
    window.addEventListener('mouseup', () => {
      if (!mDown) return;
      mDown = false;
      lightboxImg.style.cursor = 'grab';
      lightboxImg.style.transform = '';
      if (Math.abs(mMoved) > 60) { mMoved < 0 ? showImage(currentIndex + 1) : showImage(currentIndex - 1); }
      mMoved = 0;
    });
  }

  /* ── Thumbnails layout: hero swap + thumb click + nav ── */
  function initHeroGallery(block) {
    const hero = block.querySelector('[data-oa-pb-hero]');
    if (!hero) return;
    const heroImgs = Array.from(block.querySelectorAll('[data-oa-pb-hero-img]'));
    const thumbs = Array.from(block.querySelectorAll('[data-oa-pb-thumb]'));
    const prevBtn = block.querySelector('[data-oa-pb-hero-prev]');
    const nextBtn = block.querySelector('[data-oa-pb-hero-next]');
    if (!heroImgs.length) return;

    let current = 0;
    function show(index) {
      if (index < 0) index = heroImgs.length - 1;
      if (index >= heroImgs.length) index = 0;
      current = index;
      heroImgs.forEach((img, i) => img.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      const active = thumbs[index];
      if (active) {
        const bar = active.parentElement;
        if (bar && typeof bar.scrollTo === 'function') {
          const target = active.offsetLeft - (bar.clientWidth / 2) + (active.clientWidth / 2);
          bar.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
        } else if (active.scrollIntoView) {
          active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => show(i));
    });

    /* Expose voor variant-image swap (zodat we ook kunnen swappen als de thumb niet zichtbaar is) */
    block._oaPBShowHero = show;

    if (prevBtn) prevBtn.addEventListener('click', () => show(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(current + 1));

    let touchStart = 0;
    hero.addEventListener('touchstart', (e) => { touchStart = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      const diff = touchStart - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { diff > 0 ? show(current + 1) : show(current - 1); }
    }, { passive: true });

    /* Mouse-drag swiping op laptop — grab foto en sleep */
    let hDown = false, hStartX = 0, hMoved = 0;
    hero.style.cursor = 'grab';
    hero.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      hDown = true; hStartX = e.clientX; hMoved = 0;
      hero.style.cursor = 'grabbing';
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => {
      if (!hDown) return;
      hMoved = e.clientX - hStartX;
      const active = hero.querySelector('.oa-pb__hero-img.is-active');
      if (active) active.style.transform = 'translateX(' + (hMoved * 0.3) + 'px)';
    });
    window.addEventListener('mouseup', () => {
      if (!hDown) return;
      hDown = false;
      hero.style.cursor = 'grab';
      const active = hero.querySelector('.oa-pb__hero-img.is-active');
      if (active) active.style.transform = '';
      if (Math.abs(hMoved) > 60) { hMoved < 0 ? show(current + 1) : show(current - 1); }
      hMoved = 0;
    });
  }

  /* ── Mobiele swipe gallery (touch + mouse drag) ── */
  function initMobileGallery(block) {
    const gallery = block.querySelector('[data-oa-pb-mobile-gallery]');
    const dots = block.querySelectorAll('.oa-pb__dot');
    if (!gallery) return;
    /* Mouse drag-to-scroll */
    let mgDown = false, mgStartX = 0, mgScrollStart = 0;
    gallery.style.cursor = 'grab';
    gallery.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      mgDown = true;
      mgStartX = e.pageX;
      mgScrollStart = gallery.scrollLeft;
      gallery.style.cursor = 'grabbing';
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => {
      if (!mgDown) return;
      gallery.scrollLeft = mgScrollStart - (e.pageX - mgStartX) * 1.2;
    });
    window.addEventListener('mouseup', () => {
      if (!mgDown) return;
      mgDown = false;
      gallery.style.cursor = 'grab';
    });
    if (!dots.length) return;
    function updateDots() {
      const slideWidth = gallery.scrollWidth / dots.length;
      const index = Math.round(gallery.scrollLeft / slideWidth);
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }
    gallery.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.dotIndex, 10);
        gallery.scrollTo({ left: (gallery.scrollWidth / dots.length) * index, behavior: 'smooth' });
      });
    });
  }

  /* ── Variant image swap — toon afbeelding van geselecteerde variant ── */
  function swapToVariantImage(block, variantId) {
    const productId = block.dataset.productId;
    if (!productId || !window.OAVariantImages || !window.OAVariantImages[productId]) return;
    let imageId = window.OAVariantImages[productId][variantId];

    /* Geen variant-specifieke foto → terug naar de standaard (eerste) productfoto.
       Onthoud die eerste foto bij init, want na een eerdere swap kan de DOM-volgorde
       in de collage al gewisseld zijn met klasse-swap (--1 ↔ --N). */
    if (!imageId) {
      if (!block._oaDefaultImageId) {
        const firstHero = block.querySelector('[data-oa-pb-hero-img]');
        const firstCollage = block.querySelector('[data-oa-pb-collage-item]');
        const firstEl = firstHero || firstCollage;
        if (firstEl && firstEl.dataset.imageId) block._oaDefaultImageId = firstEl.dataset.imageId;
      }
      if (!block._oaDefaultImageId) return;
      imageId = block._oaDefaultImageId;
    } else if (!block._oaDefaultImageId) {
      /* Bewaar de defaults voordat we voor het eerst gaan swappen */
      const firstHero = block.querySelector('[data-oa-pb-hero-img]');
      const firstCollage = block.querySelector('[data-oa-pb-collage-item]');
      const firstEl = firstHero || firstCollage;
      if (firstEl && firstEl.dataset.imageId) block._oaDefaultImageId = firstEl.dataset.imageId;
    }

    /* Gallery ratio aanpassen aan aspect ratio van geselecteerde afbeelding —
       zo wordt een bredere variant-foto (bv. 2-persoons) niet gecropt door een vaste 3/4 ratio */
    const wrap = block.querySelector('.oa-pb__hero-wrap, .oa-pb__collage');
    const matched = block.querySelector('[data-oa-pb-hero-img][data-image-id="' + imageId + '"], [data-oa-pb-collage-item][data-image-id="' + imageId + '"] img');
    if (wrap && matched) {
      const w = parseFloat(matched.getAttribute('width')) || matched.naturalWidth || 0;
      const h = parseFloat(matched.getAttribute('height')) || matched.naturalHeight || 0;
      if (w > 0 && h > 0) {
        wrap.style.setProperty('--oa-pb-gallery-ratio', w + ' / ' + h);
      }
    }

    /* Thumbnails layout — toon de hero-foto die bij deze variant hoort.
       Direct show() aanroepen i.p.v. thumb.click(), zodat het ook werkt als de thumb buiten
       de zichtbare strook valt (thumbs_visible limiet) of als er sowieso geen thumbs zijn. */
    const heroImgs = Array.from(block.querySelectorAll('[data-oa-pb-hero-img]'));
    if (heroImgs.length) {
      const idx = heroImgs.findIndex(img => String(img.dataset.imageId) === String(imageId));
      if (idx >= 0) {
        if (typeof block._oaPBShowHero === 'function') {
          block._oaPBShowHero(idx);
        } else {
          /* Fallback als initHeroGallery (nog) niet heeft gedraaid */
          heroImgs.forEach((img, i) => img.classList.toggle('is-active', i === idx));
          block.querySelectorAll('[data-oa-pb-thumb]').forEach(t => {
            t.classList.toggle('is-active', t.dataset.index === String(idx));
          });
        }
        return;
      }
    }

    /* Collage layout — wissel modifier-klasse (oa-pb__collage-item--N) tussen matched item en huidige hero (--1).
       style.order werkt niet bij grid items met expliciete grid-column/grid-row placement. */
    const collageItems = Array.from(block.querySelectorAll('[data-oa-pb-collage-item]'));
    if (collageItems.length) {
      const modRE = /^oa-pb__collage-item--\d+$/;
      const getMod = el => Array.from(el.classList).find(c => modRE.test(c));
      const matched = collageItems.find(item => String(item.dataset.imageId) === String(imageId));
      const heroMod = 'oa-pb__collage-item--1';
      if (matched && !matched.classList.contains(heroMod)) {
        const currentHero = collageItems.find(item => item.classList.contains(heroMod));
        const matchedMod = getMod(matched);
        if (currentHero && matchedMod) {
          currentHero.classList.remove(heroMod);
          currentHero.classList.add(matchedMod);
          matched.classList.remove(matchedMod);
          matched.classList.add(heroMod);
        }
      }
    }

    /* Mobiele gallery — scroll naar de slide */
    const mobileGallery = block.querySelector('[data-oa-pb-mobile-gallery]');
    if (mobileGallery) {
      const slide = mobileGallery.querySelector('.oa-pb__mobile-slide[data-image-id="' + imageId + '"]');
      if (slide) {
        const target = slide.offsetLeft;
        mobileGallery.scrollTo({ left: target, behavior: 'smooth' });
      }
    }
  }

  /* ── Maat knoppen ── */
  function initSizeButtons(block) {
    const buttons = block.querySelectorAll('.oa-pb__size-btn');
    const priceEl = block.querySelector('[data-oa-pb-price]');
    const addBtn = block.querySelector('[data-oa-pb-add]');
    if (!buttons.length) return;

    /* Helpers: sale-badge + compare price syncen met de actieve variant.
       Anders blijft "-25%" en de doorgestreepte prijs hangen als je naar een variant
       switcht die geen korting heeft (bv. 2 persoons). */
    function syncSaleUI(btn) {
      const onSale = btn.dataset.variantOnSale === 'true';
      const compareEl = block.querySelector('.oa-pb__price-compare');
      const saleBadge = block.querySelector('.oa-pb__badge--sale');
      if (compareEl) {
        if (onSale && btn.dataset.variantComparePrice) {
          compareEl.textContent = btn.dataset.variantComparePrice;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (saleBadge) {
        if (onSale) {
          const d = parseInt(btn.dataset.variantDiscount, 10);
          if (!isNaN(d) && d > 0) saleBadge.textContent = '-' + d + '%';
          saleBadge.style.display = '';
        } else {
          saleBadge.style.display = 'none';
        }
      }
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled || btn.classList.contains('is-soldout')) return;
        buttons.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const variantId = btn.dataset.variantId;
        const variantPrice = btn.dataset.variantPrice;
        if (priceEl && variantPrice) {
          priceEl.style.opacity = '0';
          priceEl.style.transform = 'translateY(-4px)';
          setTimeout(() => {
            priceEl.textContent = variantPrice;
            priceEl.style.opacity = '1';
            priceEl.style.transform = 'translateY(0)';
          }, 150);
        }
        syncSaleUI(btn);
        if (addBtn && variantId) addBtn.dataset.variantId = variantId;
        if (variantId) {
          swapToVariantImage(block, variantId);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
          document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => { input.value = variantId; });
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId } }));
        }
      });
    });

    /* Init: sync gallery + sale UI met de variant die nu actief is (bv. via ?variant=) */
    const initialActive = block.querySelector('.oa-pb__size-btn.is-active');
    if (initialActive && initialActive.dataset.variantId) {
      swapToVariantImage(block, initialActive.dataset.variantId);
      syncSaleUI(initialActive);
    }
  }

  /* ── Add to cart — gebruikt theme's eigen popdown/drawer systeem ── */
  function initAddToCart(block) {
    const addBtn = block.querySelector('[data-oa-pb-add]');
    if (!addBtn) return;

    addBtn.addEventListener('click', () => {
      if (addBtn.classList.contains('is-loading')) return;
      const variantId = addBtn.dataset.variantId;
      if (!variantId) return;

      const textEl = addBtn.querySelector('[data-oa-pb-add-text]');
      const originalText = textEl ? textEl.textContent : '';
      addBtn.classList.add('is-loading');
      if (textEl) textEl.textContent = (block._i18n && block._i18n.adding) || 'Toevoegen...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(res => { if (!res.ok) throw new Error('Cart error'); return res.json(); })
        .then(data => {
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-success');
          if (textEl) textEl.textContent = (block._i18n && block._i18n.added) || 'Toegevoegd!';

          /* Theme cart:change event — theme.js Totals class update [data-header-cart-count] */
          fetch('/cart.js').then(r => r.json()).then(cart => {
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: { cart: cart },
              bubbles: true
            }));
            /* Update onze eigen oa-cart-count-badge (tekst + zichtbaarheid) */
            document.querySelectorAll('[data-oa-cart-count]').forEach(el => {
              el.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
              el.classList.toggle('is-hidden', cart.item_count === 0);
            });
            /* Update + bump alle gangbare cart-count badges */
            document.querySelectorAll('[data-header-cart-count], [data-oa-cart-count], [data-cart-count], .cart-count, .cart-count-bubble span').forEach(el => {
              if (!el.hasAttribute('data-oa-cart-count')) el.textContent = cart.item_count;
              el.classList.remove('oa-cart-just-bumped');
              void el.offsetWidth;
              el.classList.add('oa-cart-just-bumped');
            });
            /* Open de cart popup (oa-header-popups) automatisch */
            const cartTrigger = document.querySelector('[data-oa-popup="cart"]');
            if (cartTrigger) cartTrigger.click();
          });

          setTimeout(() => {
            addBtn.classList.remove('is-success');
            if (textEl) textEl.textContent = originalText;
          }, 2000);
        })
        .catch(() => {
          addBtn.classList.remove('is-loading');
          if (textEl) textEl.textContent = (block._i18n && block._i18n.error) || 'Fout — probeer opnieuw';
          setTimeout(() => { if (textEl) textEl.textContent = originalText; }, 2500);
        });
    });
  }

  /* ── Wishlist (gebruikt dezelfde localStorage als oa-wishlist-app.js) ── */
  function initWishlist(block) {
    const wishBtn = block.querySelector('[data-oa-pb-wish]');
    if (!wishBtn) return;

    const storageKey = 'oaWishlist';
    const handle = wishBtn.dataset.productHandle;
    if (!handle) return;

    const item = {
      handle: handle,
      title: wishBtn.dataset.productTitle || handle,
      url: wishBtn.dataset.productUrl || ('/products/' + handle),
      image: wishBtn.dataset.productImage || null
    };

    function getList() {
      try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); }
      catch (e) { return []; }
    }
    function setList(list) {
      localStorage.setItem(storageKey, JSON.stringify(list));
      updateState();
      /* Juiste event-naam: oa-wishlist-app.js luistert hierop voor live badge-update */
      window.dispatchEvent(new CustomEvent('oa-wishlist:changed', { detail: { count: list.length, list: list } }));
      document.dispatchEvent(new CustomEvent('oa-wishlist:changed', { detail: { count: list.length, list: list } }));
    }
    function updateState() {
      const active = getList().some(x => x.handle === handle);
      wishBtn.classList.toggle('is-wishlisted', active);
      wishBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }

    wishBtn.addEventListener('click', () => {
      const list = getList();
      if (list.some(x => x.handle === handle)) {
        setList(list.filter(x => x.handle !== handle));
      } else {
        item.addedAt = Date.now();
        setList([item].concat(list));
      }
    });

    updateState();
    window.addEventListener('storage', (e) => { if (e.key === storageKey) updateState(); });
  }

  /* ── Maatgids modal ── */
  function initSizeGuide(block) {
    const openBtns = block.querySelectorAll('[data-oa-size-guide-open]');
    const overlay = block.querySelector('[data-oa-size-guide-overlay]');
    if (!overlay) return;

    function open(e) { e.preventDefault(); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

    openBtns.forEach(btn => btn.addEventListener('click', open));
    block.querySelectorAll('[data-oa-size-guide-close]').forEach(btn => btn.addEventListener('click', close));
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  /* ── Accordion tabs ── */
  function initTabs(block) {
    const tabBtns = block.querySelectorAll('[data-oa-pb-tab]');
    if (!tabBtns.length) return;
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.closest('.oa-pb__tab');
        if (!tab) return;
        block.querySelectorAll('.oa-pb__tab.is-open').forEach(t => { if (t !== tab) t.classList.remove('is-open'); });
        tab.classList.toggle('is-open');
      });
    });
  }

  /* ── Designs modal — fullscreen grid (portal naar body) ── */
  function initDesignsModal(block) {
    let overlay = block.querySelector('[data-oa-designs-modal]') || document.querySelector('[data-oa-designs-modal][data-portaled="' + block.dataset.productId + '"]');
    if (!overlay) return;
    const openBtns = block.querySelectorAll('[data-oa-designs-open]');

    function ensurePortaled() {
      if (overlay.parentNode !== document.body) {
        overlay.dataset.portaled = block.dataset.productId || '1';
        document.body.appendChild(overlay);
      }
    }
    ensurePortaled();
    const closeBtns = overlay.querySelectorAll('[data-oa-designs-close]');

    function open(e) {
      if (e) e.preventDefault();
      ensurePortaled();
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const active = overlay.querySelector('.oa-pb__design-card.is-active, .oa-pb__design-tile.is-active');
      if (active) requestAnimationFrame(() => active.scrollIntoView({ block: 'center', behavior: 'auto' }));
    }
    function close() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

    openBtns.forEach(btn => btn.addEventListener('click', open));
    closeBtns.forEach(btn => btn.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  /* ── Sticky cart op mobiel ── */
  function initStickyCart(block) {
    const sticky = block.querySelector('[data-oa-pb-sticky]');
    const mainAdd = block.querySelector('[data-oa-pb-add]');
    if (!sticky || !mainAdd) return;

    const stickyAdd = sticky.querySelector('[data-oa-pb-sticky-add]');
    const stickyText = sticky.querySelector('[data-oa-pb-sticky-text]');
    const stickyPrice = sticky.querySelector('[data-oa-pb-sticky-price]');
    const priceEl = block.querySelector('[data-oa-pb-price]');

    /* Variant-id en prijs in sync houden met de hoofd-cart-knop */
    const syncVariant = () => {
      if (mainAdd.dataset.variantId) stickyAdd.dataset.variantId = mainAdd.dataset.variantId;
      if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
    };
    syncVariant();
    document.addEventListener('variant:change', syncVariant);
    new MutationObserver(syncVariant).observe(mainAdd, { attributes: true, attributeFilter: ['data-variant-id'] });
    if (priceEl) new MutationObserver(syncVariant).observe(priceEl, { childList: true, characterData: true, subtree: true });

    /* Toon sticky-bar wanneer hoofdknop niet meer in beeld is */
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
          sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      obs.observe(mainAdd);
    } else {
      sticky.classList.add('is-visible');
    }

    /* Add-to-cart vanuit sticky-bar — hergebruik dezelfde flow */
    stickyAdd.addEventListener('click', () => {
      if (stickyAdd.classList.contains('is-loading')) return;
      const variantId = stickyAdd.dataset.variantId || mainAdd.dataset.variantId;
      if (!variantId) return;
      const originalText = stickyText ? stickyText.textContent : '';
      stickyAdd.classList.add('is-loading');
      if (stickyText) stickyText.textContent = (block._i18n && block._i18n.adding) || 'Toevoegen...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(res => { if (!res.ok) throw new Error('Cart error'); return res.json(); })
        .then(() => {
          stickyAdd.classList.remove('is-loading');
          stickyAdd.classList.add('is-success');
          if (stickyText) stickyText.textContent = (block._i18n && block._i18n.added) || 'Toegevoegd!';
          /* Sticky balk op telefoon: open het winkelwagen-drawer i.p.v. de 'toegevoegd'-popup. */
          document.dispatchEvent(new CustomEvent('oa:open-cart'));
          fetch('/cart.js').then(r => r.json()).then(cart => {
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(el => { el.textContent = cart.item_count; });
          });
          setTimeout(() => {
            stickyAdd.classList.remove('is-success');
            if (stickyText) stickyText.textContent = originalText;
          }, 2000);
        })
        .catch(() => {
          stickyAdd.classList.remove('is-loading');
          if (stickyText) stickyText.textContent = (block._i18n && block._i18n.error_short) || 'Fout';
          setTimeout(() => { if (stickyText) stickyText.textContent = originalText; }, 2500);
        });
    });
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductBlock);
  } else {
    initProductBlock();
  }
  document.addEventListener('shopify:section:load', initProductBlock);
})();
